import Header from '../../../Components/Header/Header';
import styles from './about.module.scss';
import { Helmet } from 'react-helmet-async';
import useInView from '../../../Components/UseInView/useInView';
import RevealImage from '../../../Components/RevealImage/revealImage';
import Button from '../../../Components/Button/Button';
import Cta from '../../../Components/Cta/Cta';
import Footer from '../../../Components/Footer/Footer';
import Faq from '../../../Components/Faq/Faq';
import HistoryTimeline from '../../../Components/HistoryTimeline/HistoryTimeline';

const About = () => {
    const [aboutLandingRef, aboutLandingVisible] = useInView();
    const [faqRef, faqVisible] = useInView();

    return (
        <>
            <Helmet>
                <title>Clear Property Management - Property Management Services</title>
                <meta name='description' content='We provide property management services.' />
                <link rel='canonical' href='/' />
            </Helmet>
            <Header />

            <p>[About Us]</p>
            <h1>Our Story</h1>

            <div
                id='About Landing'
                ref={aboutLandingRef}
                className={`${styles.aboutLandingContainer} ${aboutLandingVisible ? styles.visible : ''}`}
            >
                <div className={styles.landingContainerLeft}>
                    <h1>Tailored Property Solutions for Every Space</h1>
                    <div className={styles.landingContainerLeftDetail}>
                        <div className={styles.landingContainerLeftDetailLeft}>
                            <p>
                                At Clear Property Management, we are a dedicated team of property
                                professionals committed to delivering reliable, full-service
                                management solutions tailored to the unique needs of each property
                                and client.
                            </p>
                            <div className={styles.landingContainerStats}>
                                <div>
                                    <h2>100+</h2>
                                    <h4>Properties</h4>
                                </div>
                                <div>
                                    <h2>98%</h2>
                                    <h4>Client Satisfaction Rate</h4>
                                </div>
                            </div>
                            <Button buttonText='Contact Us' displayIcon={true} link='/contact' />
                        </div>
                        <div className={styles.landingContainerLeftDetailRight}>
                            <RevealImage
                                src='https://cdn.prod.website-files.com/6787fd6e047993a568043b60/6787fd6e047993a568043bf9_details-image-01.jpg'
                                alt='landing'
                                imageStyle={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                }}
                                rollUpColor='#f6f6f6'
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.landingContainerRight}>
                    <RevealImage
                        src='https://images.unsplash.com/photo-1588835743485-5845e40364fe?q=80&w=2268&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'
                        alt='landing'
                        imageStyle={{
                            width: '100%',
                            height: '100%',
                            maxHeight: '600px',
                            objectFit: 'cover',
                        }}
                        rollUpColor='#f6f6f6'
                    />
                </div>
            </div>

            <div>
                <HistoryTimeline />
            </div>

            <div
                id='Faq'
                ref={faqRef}
                className={`${styles.sectionContainer} ${faqVisible ? styles.visible : ''}`}
            >
                <div className={styles.sectionInnerContainer}>
                    <div className={styles.faqLeftBox}>
                        <div>
                            <p>[FAQ]</p>
                            <h1>Frequently Asked Questions</h1>
                        </div>
                        <div>
                            <h3>Still Have Questions?</h3>
                            <p>
                                Can’t find the answer you’re looking for? Please contact with our
                                customer service.
                            </p>
                            <Button buttonText='Contact Us' displayIcon={true} link='/contact' />
                        </div>
                    </div>
                </div>
                <div className={styles.sectionInnerContainer}>
                    <Faq
                        faqs={[
                            {
                                id: 1,
                                question: 'What services do you provide?',
                                answer: 'Our full-service management includes tenant placement, rent collection, maintenance coordination, property inspections, legal compliance, and detailed financial reporting.',
                            },
                            {
                                id: 2,
                                question: 'How do you screen potential tenants?',
                                answer: 'We conduct a thorough screening process including credit checks, income verification, employment history, reference checks, and a review of previous rental behavior.',
                            },
                            {
                                id: 3,
                                question: 'How are maintenance requests handled?',
                                answer: 'Tenants can submit maintenance requests online or by phone. We respond promptly, dispatch trusted contractors, and keep you informed throughout the process.',
                            },
                            {
                                id: 4,
                                question: 'How and when do property owners get paid?',
                                answer: 'We collect rent at the start of each month and disburse payments to property owners typically within the first 7 business days, along with a detailed statement.',
                            },
                            {
                                id: 5,
                                question: 'What areas do you currently serve?',
                                answer: 'We proudly serve Waterloo, Kitchener, Guelph, Cambridge, and surrounding areas in Southern Ontario.',
                            },
                        ]}
                    />
                </div>
            </div>

            <div id='Cta' className={`${styles.sectionContainer} ${styles.visible}`}>
                <Cta />
            </div>

            <Footer />
        </>
    );
};

export default About;
